module.exports = __webpack_public_path__ + "img/15.ae468a68.png";